import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/Button.js';
import { ServiceStatusCard } from '../ui/ServiceStatusCard.js';
import { t } from '../i18n/index.js';
import './HomePage.css';

/**
 * Page d'accueil.
 *
 * Les boutons de mission sont volontairement inactifs tant que la selection de
 * scenarios (lot 7) n'est pas livree : ils annoncent la fonctionnalite au lieu
 * de mener a un ecran vide.
 */
export function HomePage() {
  const labels = t();
  const navigate = useNavigate();

  return (
    <div className="fg-home">
      <section className="fg-home__hero">
        <p className="fg-home__eyebrow">{labels.app.tagline}</p>
        <h1>{labels.home.heroTitle}</h1>
        <p className="fg-home__lead">{labels.home.heroSubtitle}</p>

        <div className="fg-home__actions">
          <Button size="lg" onClick={() => void navigate('/demonstration')}>
            {labels.home.openDemo}
          </Button>
          <Button size="lg" variant="secondary" disabled title={labels.home.availableSoon}>
            {labels.home.startMission}
          </Button>
          <span className="fg-home__hint">{labels.home.demoHint}</span>
        </div>
      </section>

      <div className="fg-home__columns">
        <section className="fg-home__pillars" aria-label={labels.app.name}>
          <article className="fg-home__pillar">
            <h2>{labels.home.pillars.simulation.title}</h2>
            <p>{labels.home.pillars.simulation.text}</p>
          </article>
          <article className="fg-home__pillar">
            <h2>{labels.home.pillars.resources.title}</h2>
            <p>{labels.home.pillars.resources.text}</p>
          </article>
          <article className="fg-home__pillar">
            <h2>{labels.home.pillars.stakes.title}</h2>
            <p>{labels.home.pillars.stakes.text}</p>
          </article>
        </section>

        <aside className="fg-home__aside">
          <ServiceStatusCard />
        </aside>
      </div>
    </div>
  );
}
